export const SELECTOR_CONFIGS_UNITS = (state) => state.configs.units;
